import { createAsyncThunk } from '@reduxjs/toolkit'
import { BomItemController } from 'controllers/Project/BomItemController'
import {
  AssemblyDto,
  RowDto,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { getContext } from 'store/getContext'
import { newProjectActions } from '../newProjectReducer'
import { fetchProject } from './fetchProject'

export const saveBomItemName = createAsyncThunk<any, any, { state: any }>(
  'boM/saveBomItemName',
  async (
    {
      bomItemId,
      name,
    }: {
      bomItemId: string
      name: string
      preferTreeView?: boolean
    },
    thunkAPI
  ) => {
    const { partyId: organizationId, projectId } = getContext(thunkAPI.getState)

    thunkAPI.dispatch(
      newProjectActions.setBomItemProperties({
        id: bomItemId,
        name: name,
      } as AssemblyDto | RowDto)
    )

    const controller = new BomItemController(organizationId, projectId)

    try {
      await controller.SetBomItemName(bomItemId, name)
    } catch (err) {
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)
